import React, {useReducer} from 'react'
export const AuthContext = React.createContext();
const authReducer = (state,action) => {
    switch(action.type){
        case 'login':
            const access_token = action.payload.access
            const refresh_token = action.payload.refresh
            localStorage.setItem('access_token', access_token);
            localStorage.setItem('refresh_token', refresh_token);
            console.log(action.payload)
            return {state:access_token}
            break
        case 'check':
            const token = localStorage.getItem('access_token')
            const refresh = localStorage.getItem('refresh_token')
            if (!token || !refresh){
                action.payload.history.replace('/login')
            }
            break
        case 'logout':
            localStorage.removeItem('access_token')
            localStorage.removeItem('refresh_token')
            action.payload.history.replace('/login')
            break
        default:
            return state;


    }
}
const AuthContextProvider = (props) => {
    const [state, dispatch] = useReducer(authReducer,'')
    return(
        <AuthContext.Provider value={{state,dispatch}}>
            {props.children}
        </AuthContext.Provider>
    )
}
export default AuthContextProvider